import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { VideoCamera, BookOpen } from "@phosphor-icons/react";
import api, { coverSrc } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import CourseMonogram from "@/components/CourseMonogram";

export default function SallesDeCours() {
  const [courses, setCourses] = useState([]);
  const navigate = useNavigate();
  useEffect(() => { api.get("/courses").then((r) => setCourses(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="classrooms-page">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent">Campus virtuel</p>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">Salles de cours</h1>
        <p className="text-sm text-muted-foreground">Rejoignez les sessions de visioconférence de vos cours.</p>
      </div>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {courses.length === 0 && <p className="text-sm text-muted-foreground">Aucun cours disponible.</p>}
        {courses.map((c) => (
          <div key={c.id} className="flex flex-col overflow-hidden rounded-xl border border-border bg-card" data-testid={`classroom-${c.id}`}>
            <div className="relative h-28">
              {coverSrc(c.cover_image) ? (
                <img src={coverSrc(c.cover_image)} alt={c.title} className="h-full w-full object-cover" />
              ) : (
                <CourseMonogram code={c.code} title={c.title} className="h-full w-full" />
              )}
            </div>
            <div className="flex flex-1 flex-col p-5">
              <h3 className="font-display text-lg font-bold leading-tight">{c.title}</h3>
              <p className="text-sm text-muted-foreground">{c.teacher_name}</p>
              <div className="mt-3 flex-1" />
              {c.meeting_url ? (
                <a href={c.meeting_url} target="_blank" rel="noreferrer">
                  <Button className="w-full bg-accent hover:bg-accent/90" data-testid={`join-${c.id}`}><VideoCamera size={18} className="mr-2" weight="fill" /> Rejoindre la salle</Button>
                </a>
              ) : (
                <Button variant="outline" className="w-full" onClick={() => navigate(`/app/cours/${c.id}`)}>
                  <BookOpen size={16} className="mr-2" /> Voir le cours
                </Button>
              )}
              {!c.meeting_url && <Badge variant="secondary" className="mt-2 self-start">Aucune session planifiée</Badge>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
